import Error from 'es6-error'
/**
 * Glonass custom errors definitions.
 */
/**
 * @constructor
 * @extends Error
 */
export class LogicError extends Error {
}

/**
 * @constructor
 * @extends LogicError
 */
export class InvalidArgumentError extends LogicError {
}

/**
 * @constructor
 * @extends Error
 */
export class RuntimeError extends Error {
}

/**
 * @constructor
 * @extends RuntimeError
 */
export class NotImplementedError extends RuntimeError {
}

/**
 * @constructor
 * @extends Error
 */
export class XHRError extends Error {
    constructor(message, response) {
        super(message)
        this.response = response
    }
}

/**
 * @constructor
 * @extends XHRError
 */
export class RequestFailedError extends XHRError {
}

/**
 * @constructor
 * @extends Error
 */
export class SecurityError extends Error {
}

/**
 * @constructor
 * @extends SecurityError
 */
export class AccessDeniedError extends SecurityError {
}

/**
 * @constructor
 * @extends Error
 */
export class EventError extends Error {
}

export class ValidationError extends Error {
}
